import { createEditBlock } from "./base-edit-block";

export const toneChangeBlock = createEditBlock("tone-change", {
  responseToPatch: (text) => ({ text }),
  additionalParams: (options) => ({
    tone: options?.tone,
  }),
});
